import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import ReportRoundedIcon from "@mui/icons-material/ReportRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import { Button, GridLegacy } from "@mui/material";
import { red } from "@mui/material/colors";

export default function ModalContainer(props: any) {
  const [open, setOpen] = React.useState(true);

  React.useEffect(() => {
    if (!open) {
      setOpen(true);
    }
  }, [props]);

  const title = () => {
    switch (props.dlgType) {
      case "Предупреждение":
        return <ReportRoundedIcon fontSize="large" />;
      case "Ошибка":
        return <ErrorRoundedIcon fontSize="large" sx={{ color: red[500] }} />;
      case "Информация":
        return <InfoRoundedIcon fontSize="large" />;
      case "Вопрос":
        return; //<QuestionMarkRoundedIcon  fontSize='large'/>
    }
  };

  const DefaultButtonOk = () => {
    return (
      <Button style={{ textTransform: "none" }} onClick={handleClose} variant="outlined">
        Ок
      </Button>
    );
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={props.open === undefined ? open : props.open}
        slots={{
          transition: Slide,
        }}
        slotProps={{
          transition: {
            direction: "up",
          },
        }}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{props.dlgType}</DialogTitle>
        <DialogContent>
          <GridLegacy container direction="row" justifyContent="center" alignItems="center" spacing={2}>
            <GridLegacy item>{title()}</GridLegacy>
            <GridLegacy item>
              <DialogContentText>{props.content}</DialogContentText>
            </GridLegacy>
          </GridLegacy>
        </DialogContent>
        <DialogActions>
          <div id="DialogActionTest">{props.buttons ? props.buttons : <DefaultButtonOk />}</div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
